import React from "react";
import "./highroof-van.css";

const servicesData = [
  {
    title: "Packing Safely",
    desc: "We focus on securely packaging your belongings during transit. Our experienced team uses the finest materials and techniques to protect everything, whether heavy or fragile, and whether the delivery is through a regular van or a chiller van, ensuring safe and damage-free transport every time.",
  },
  {
    title: "Quality Service",
    desc: "We deliver exceptional service with punctuality and care. Our quality in providing chiller, freezer, and dry transport through their dedicated vans is at its peak. From start to finish, our team offers expert assistance, ensuring a smooth, secure, and high-quality delivery experience that fully meets your needs.",
  },
  {
    title: "Clean Vehicle",
    desc: "Hygiene is our top priority in every van we provide. Each vehicle is thoroughly cleaned and sanitized to ensure your goods are transported in a clean and safe environment, keeping your supplies secure and in optimal condition.",
  },
  {
    title: "Fastest Delivery",
    desc: "We guarantee quick delivery of your items, valuing your time! With our well-maintained, spotless vehicles and experienced drivers, your goods will arrive on time and safely. Trust us to meet your deadlines!",
  },
];

const ServiceHighRoof = () => {
  const phoneNumber = "+971544792905";

  return (
    <section className="service-hr-section">
      <div className="service-hr-container">
        <div className="service-hr-header" data-aos="fade-down" data-aos-delay="200">
          <h2> Transport in Dubai</h2>
          <p>
            We provide end-to-end transport solutions focused on secure packing, 
            high service quality, hygienic vehicles, and fast delivery. Our fleet ensures
            your chilled and frozen goods are delivered safely across Dubai and UAE.
          </p>
        </div>

        <div className="service-hr-grid">
          {servicesData.map((service, index) => (
            <div key={index} className="single-service-card" data-aos="zoom-in" data-aos-delay="300">
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <div>
                <a href={`tel:${phoneNumber}`} className="btn--primary bg-light text-dark">
                  Call Now
                </a>
                
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>




  );
};

export default ServiceHighRoof;